import countries from './countries.json'

const getCountries = () => {
    return countries.map((country) => {
        return {
            label: country.name,
            value: country.code
        }
    })
}

export default {
    getCountries
}